import { SimpleGrid } from "@chakra-ui/react";
import type { ReactElement } from "react";
import type { HomeConfig, PanelKind } from "./homeConfig";
import { GreetingHeader } from "./GreetingHeader";
import { HeroActions } from "./HeroActions";
import { ActiveProcurementsPanel } from "./panels/ActiveProcurementsPanel";
import { ActiveContractsPanel } from "./panels/ActiveContractsPanel";
import { LatestDraftsPanel } from "./panels/LatestDraftsPanel";
import { MyNeedsPanel } from "./panels/MyNeedsPanel";

const PANEL: Record<PanelKind, () => ReactElement> = {
  activeProcurements: ActiveProcurementsPanel,
  latestDrafts: LatestDraftsPanel,
  myNeeds: MyNeedsPanel,
  activeContracts: ActiveContractsPanel,
};

export const HomeShell = ({ config }: { config: HomeConfig }) => (
  <>
    <GreetingHeader headlineKey={config.headlineKey} />
    <HeroActions actions={config.heroActions} />
    <SimpleGrid columns={{ base: 1, lg: 2 }} spacing="4">
      {config.panels.map((kind) => {
        const Panel = PANEL[kind];
        return <Panel key={kind} />;
      })}
    </SimpleGrid>
  </>
);
